<div class="container">
  <ng-container *ngTemplateOutlet="formRegister"></ng-container>
</div>

<ng-template #formRegister>
  <div style="margin: 10px 10px 0 0; display: flex; justify-content: center">
    <mat-chip-listbox
      #chipList
      aria-label="Fruit selection"
      style="display: flex; flex-direction: row; align-items: center"
      >
      @for (data of chipUsers; track data) {
        <mat-chip-option
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(data)"
          >
          {{ data.nombre }}
          @if (removable) {
            <mat-icon matChipRemove>cancel</mat-icon>
          }
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
  <form
    [formGroup]="formR"
    (ngSubmit)="formR.valid ? saveRegister(formR.value) : errorMessage()"
    style="overflow: auto"
    >
    <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
      <div style="display: flex; width: 100%; margin-top: 10px">
        <div [style.flex]="10">
          <div class="first-row">
            <div class="row-item">
              <combos
                [configuration]="combosConfigUsers"
                [reloadCombo]="reloadComboUsers"
                [required]="true"
                [filter]="true"
                [control]="formR.get('userIds')"
                [checkbox]="true"
                (changeOptionDataComplete)="getDataComboUsers($event)"
                (returnDataCombo)="returnDataComboUsers($event)"
                [disabled]="edit"
                >
              </combos>
            </div>
          </div>
          @if (!exit) {
            <div class="default-row">
              <div class="row-item">
                <mat-form-field [appOpenDatepickerOnClick]="pickerEntry">
                  <mat-label>Fecha Entrada</mat-label>
                  <input
                    [matDatepicker]="pickerEntry"
                    autocomplete="off"
                    matInput
                    required
                    formControlName="entryDate"
                    />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerEntry">
                  </mat-datepicker-toggle>
                  <mat-datepicker
                    #pickerEntry
                    [touchUi]="movil ? true : false"
                  ></mat-datepicker>
                  <mat-error>Campo requerido</mat-error>
                </mat-form-field>
              </div>
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Hora Entrada</mat-label>
                  <input
                    matInput
                    [ngxTimepicker]="pickerHE"
                    formControlName="entryTime"
                    required
                    />
                  <ngx-material-timepicker #pickerHE></ngx-material-timepicker>
                </mat-form-field>
              </div>
            </div>
          }

          <div class="default-row">
            <div class="row-item">
              <mat-form-field [appOpenDatepickerOnClick]="pickerExit">
                <mat-label>Fecha Salida</mat-label>
                <input
                  [matDatepicker]="pickerExit"
                  autocomplete="off"
                  matInput
                  formControlName="exitDate"
                  />
                <mat-datepicker-toggle matIconSuffix [for]="pickerExit">
                </mat-datepicker-toggle>
                <mat-datepicker
                  #pickerExit
                  [touchUi]="movil ? true : false"
                ></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <mat-label>Hora Salida</mat-label>
                <input
                  matInput
                  [ngxTimepicker]="pickerHS"
                  formControlName="exitTime"
                  />
                <ngx-material-timepicker #pickerHS></ngx-material-timepicker>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div style="flex: 0.2">
          <button
            mat-mini-fab
            color="warn"
            type="button"
            (click)="saveRegister(formR.value)"
            >
            <mat-icon>save</mat-icon>
          </button>
        </div>
      </div>

  </cdk-virtual-scroll-viewport>
</form>
</ng-template>
